import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';
import { getActiveTintColor, getSelectedTintColors } from 'features/product-info';
import { getIsTintServiceAvailableInRegion } from 'features/page-model';

const featureRootSelector = createFeatureSelector('basket');

const measurementSettingsSelector = createFeatureSelector('measurementSettings');

export const getBasket = createSelector(featureRootSelector, (b) => b ?? []);

export const getCartItem = (productId: string) =>
  createSelector(getBasket, (basket) => basket?.find(({ code }) => code === productId));

export const getMeasurementSettings = createSelector(measurementSettingsSelector, (ms) => ms);

export const getProductQuantityAccordingToSelectedServices = (productId: string) =>
  createSelector(
    getCartItem(productId),
    getIsTintServiceAvailableInRegion,
    getActiveTintColor,
    getSelectedTintColors,
    (cartItem, isTintServiceAvailableInRegion, activeTintColor, selectedTintColors) => {
      const totalProductQuantityInBasket = cartItem?.quantity || 0;

      if (!isTintServiceAvailableInRegion) {
        return totalProductQuantityInBasket;
      }

      const isUserSelectColorInColorPalette = activeTintColor !== null;

      if (isUserSelectColorInColorPalette) {
        return activeTintColor.serviceQuantity;
      }

      const isUserSelectNoTintInColorPalette = selectedTintColors.length > 0;

      if (isUserSelectNoTintInColorPalette) {
        const totalQuantityForTintServices = selectedTintColors.reduce(
          (accumulator, currentValue) => accumulator + currentValue.serviceQuantity,
          0,
        );

        return totalProductQuantityInBasket - totalQuantityForTintServices;
      }

      return totalProductQuantityInBasket;
    },
  );
